import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { uniqBy } from 'lodash';
import { BaseModalComponent } from '../../../core/layout/components/abstracts/base-modal.component';
import { CardActionLogTypes } from '../../../features/cart/core/enums/CardActionLogTypes';
import { ICardActionLog } from '../../../features/cart/core/interfaces/ICardActionLog';
import { CartStore } from '../../../features/cart/core/stores/CartStore';
import { TerminalWsService } from '../../../features/terminals/core/services/TerminalWsService';
import { NumberToCurrencyPipe } from '../../pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../pipes/trans.pipe';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-ec-terminal-action-logs-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    NumberToCurrencyPipe,
    DatePipe,
    CommonModule
  ],
  templateUrl: './ec-terminal-action-logs-modal.component.html',
  styleUrl: './ec-terminal-action-logs-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EcTerminalActionLogsModalComponent extends BaseModalComponent<number> {

  public cardActionLogs: ICardActionLog[] = [];
  public isFinished = false;
  public readonly cartStore = inject(CartStore);
  public readonly cardActionLogTypes = CardActionLogTypes;
  private readonly _terminalWsService = inject(TerminalWsService);

  public override open(val?: number): void {
    this.cardActionLogs = [];
    this.isFinished = false;
    super.open(val);

    this._terminalWsService.onCardActionStatusChanged(payload => {
      this.cardActionLogs = uniqBy([...this.cardActionLogs, payload.result], 'message');
      this.isFinished = this.cardActionLogs.some(log => log.type === CardActionLogTypes.Success) || this.cardActionLogs.some(log => log.type === CardActionLogTypes.Error);
      this.cdr.detectChanges();
    });
  }

  public get cardActionStatus(): CardActionLogTypes {
    return this.cardActionLogs.at(-1)?.type;
  }
}
